import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {StoreService} from '../../shared/store/store.service';
import {EventService} from '../../shared/event/event.service';
// import { CognitoAuthService } from '../../shared/auth/cognito.service';

declare const _;

@Component({
    selector: 'events-table',
    templateUrl: './events-table.component.html',
    styleUrls: ['./events-table.component.css']
})
export class EventsTableComponent implements OnInit, OnDestroy {

    @Input() deviceIP = '';

    events: any[ ] = [];
    eventsParams: any[ ] = [
        {
            timePeriod: 'a',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'h',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'd',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'w',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'm',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'q',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'y',
            ip: null,
            param3: null,
        }
    ];
    subscriptions: any = {
        autoRefresh: null,
        events: null
    };

    timePeriods = ['a', 'h', 'd', 'w', 'm', 'q', 'y'];
    timePeriodIndex = 3;

    isEventsDataLoading = true;
    isEventsDataError = false;

    risks = ['INFO', 'LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];
    riskClasses = ['bg-risk-info', 'bg-risk-low', 'bg-risk-medium', 'bg-risk-high', 'bg-risk-critical'];
    icons = ['bomb', 'bug', 'sliders', 'crosshairs', 'info-circle'];

    sortByFields = [['event_id', 'event_ts'], ['event_ts'], ['name', 'event_ts'], ['orig_ip', 'orig_port'], ['resp_ip', 'resp_port'], ['arg1', 'arg2', 'arg3']];
    sortIndex = 0;
    sortAscending = false;

    constructor(private store: StoreService,
                private eventService: EventService) {
    }

    ngOnInit() {

        const self = this;

        self.subscriptions.timePeriod = self.store.onChange('timePeriod', function (timePeriod) {

            console.log('qqq Events for timePeriod = ', timePeriod);

            self.changeTimePeriod(timePeriod);
        });

        self.subscriptions.autoRefresh = self.store.onChange('autoRefresh', function (val) {

            console.log('>>>>>>>> Refreshing events! >>>>>>>> ', val);

            self.refresh();
        });

        // self.subscriptions.events = self.store.onChange('events', function (events) {
        //     self.events = events;
        // });

        // this.refresh(false);
    }

    refresh(silent = true) {
        this.getEvents(this.timePeriodIndex, true, silent);
    }

    getEvents(eventsParamsIndex, forceFetchEventsFromAPI = false, silent = false) {

        const self = this;

        if (!silent) {
            self.isEventsDataLoading = true;
        }

        const params = self.eventsParams[eventsParamsIndex];
        // inject the IP quietly here
        if (this.deviceIP) {
            params.ip = this.deviceIP;
        }

        self.eventService.getEvents(params, forceFetchEventsFromAPI).subscribe(function (events) {

            self.events = events;
            // self.store.update('events', events);
            self.isEventsDataLoading = false;
            self.isEventsDataError = false;

            // console.dir(self.events);

        }, function (err) {

            console.log('Error in getting events. Called from events-table.component.ts');
            console.log(err);

        });

    }

    sortBy(i) {

        // console.log('Sorting alerts by ', this.sortByFields[i], '...');

        if (this.sortIndex === i) {
            this.sortAscending = !this.sortAscending;
        } else {
            this.sortAscending = false;
        }

        this.sortIndex = i;
        this.events = _.sortBy(this.events, this.sortByFields[i]);
        if (!this.sortAscending) {
            this.events = _.reverse(this.events);
        }
    }

    changeTimePeriod(t) {
        const index = this.timePeriods.indexOf(t);
        if (index > -1) {
            this.timePeriodIndex = index;
            this.getEvents(index);
        }
    }

    ngOnDestroy() {

        // console.log('onDestroy called on EventsTableComponent');

        const self = this;

        Object.keys(self.subscriptions).forEach(function (key) {
            if (self.subscriptions[key]) {
                self.subscriptions[key].unsubscribe();
            }
        });
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/events-table/events-table.component.ts